import { render, staticRenderFns } from "./PensionEntityEditor.vue?vue&type=template&id=6299debe&scoped=true"
import script from "./PensionEntityEditor.vue?vue&type=script&lang=js"
export * from "./PensionEntityEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6299debe",
  null
  
)

export default component.exports